import { render, staticRenderFns } from "./PalletViewModal.vue?vue&type=template&id=352be81a"
import script from "./PalletViewModal.vue?vue&type=script&lang=ts"
export * from "./PalletViewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports